/*
 * @Author: ppttfish@163.com
 * @LastEditors: ppttfish@163.com
 * @Date: 2023-04-06 10:15:53
 * @LastEditTime: 2023-06-27 14:52:54
 */
import { ImagePreview } from 'vant'

export const useImagePreview = () => {
  const handleImgPreview = (urlList, index) => {
    if (!urlList) {
      throw Error('传入的图片列表不能为空')
    }
    const images = urlList.map(item => item.url || item)
    ImagePreview({
      images,
      startPosition: index
    })
  }

  return {
    handleImgPreview
  }
}
